var exports = {
  "k": "container__Fd-fp_",
};

module.exports = exports;
